import styled from "styled-components";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";

// Table Example from select-users.js
// Need to make this table styling used in other pages. Right now we have a lot of duplicate code to redeclare styles for each table.

/* 
<TableContainer>
  <Table>
    <TableHead>
      <TableHeadRow>
        <HeadCell>
          <Icon
            className="material-icons"
            onClick={() => handleCheckAllClick()}
            style={{
              color: checkAll ? "#14ab40" : "#5a5a5a",
              cursor: "pointer",
            }}
          >
            {checkAll ? "check_circle" : "radio_button_unchecked"}
          </Icon>
        </HeadCell>
        <HeadCell>Email Address</HeadCell>
        <HeadCell>Full Name</HeadCell>
      </TableHeadRow>
    </TableHead>
    <TableBody>
      {potentialRecipients.filter(selectFilter).map((item, index) => {
        return (
          <TableBodyRow key={index}>
            <DataCell>
              <Icon
                className="material-icons"
                onClick={() => handleCheckboxClick(item.id)}
                style={{
                  color: selected.includes(item.id)
                    ? "#14ab40"
                    : "#5a5a5a",
                }}
              >
                {selected.includes(item.id)
                  ? "check_circle"
                  : "radio_button_unchecked"}
              </Icon>
            </DataCell>
            <DataCell>{item.email_address}</DataCell>
            <DataCell>{item.name}</DataCell>
          </TableBodyRow>
        );
      })}
    </TableBody>
  </Table>
</TableContainer>
*/

export const BulkEdit = styled.button`
  background: ${(props) =>
    props.highlight ? props.theme.color.primary : props.theme.color.dark};
  border: none;
  border-radius: 100px;
  color: #fff;
  cursor: pointer;
  font-size: .8rem;
  padding: 6px 12px;
  margin-left: 8px;
  transition: 0.3s ease all;
`;

export const BulkAction = styled(BulkEdit)`
  background: ${(props) => props.theme.color.dark};
`;

export const WhiteCheckbox = withStyles({})((props) => (
  <Checkbox color="default" {...props} />
));

export const TableContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 400px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`;

export const Table = styled.table`
  background: #fff;
  border-spacing: 0px;
  width: 100%;
`;

export const TableHead = styled.thead`
  color: #fff;
`;

export const TableBody = styled.tbody``;

export const TableHeadRow = styled.tr`
  background: #070c29 !important;
`;

export const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`;

export const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${(props) => (props.bigWidth ? "160px" : "100px")};
  padding: 4px 8px;
  position: sticky;
  text-align: left;
  top: 0;
  z-index: 30;
`;

export const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px 8px;
  text-align: left;
`;
